export const BroadcastButton = function () {
  const popup_option = {
    backdrop: 'static',
    extra_class: ['broadcast-confirm-modal', 'sn-modal-scaleable'],
    keyboard: false
  };

  return {
    status: "loading",
    nid: '',
    sid: 0,
    backend: 4,
    state_key: '',
    is_recording: false,
    get text() {
      if (this.status === 'starting' || this.status === 'stopping') {
        return $jq.i18n.prop('msg_please_wait') + "...";
      }
      if (this.status === 'stopped') {
        return "Start Broadcast & Recording";
      }
      if (this.status === 'started') {
        if (this.is_recording) {
          return "Stop Broadcast & Recording";
        }
        return "Stop Broadcast";
      }
      return "Checking Broadcast State...";
    },
    get is_waiting() {
      return this.status === 'starting' || this.status === 'stopping';
    },
    state_fetcher: null,
    init: function () {
      /**
       * @type HTMLElement
       */
      const ele = this.$el;
      ele.innerHTML = `<i class="fa fa-pause" x-show="is_waiting" style="margin-right:5px;"></i><span x-bind:class="status === 'loading' ? 'blink_me' : ''" x-text="text">Checking Broadcast State...</span>`;
      ele.setAttribute('x-on:click.prevent.stop.throttle', 'handleClick');
      ele.classList.add('bsc_evt_listener');

      let nid = ele.getAttribute('data-nid');
      const content_id = tryget(() => Toolbox.snExpoLocation.current.current_content.content_id, 0) || 0;
      if (content_id && content_id != nid) {
        nid = content_id;
      }

      this.nid = nid;
      this.sid = parseInt(ele.getAttribute('data-sid') ?? '0') || 0;
      this.backend = parseInt(ele.getAttribute('data-backend') ?? '4') || 4;
      this.state_key = `broadcast_${this.nid}`;

      this.$watch('status', (val) => {
        if (val === 'started') {
          ele.setAttribute('data-action', 'stop');
          ele.setAttribute('title', '');
          ele.classList.add('btn', 'btn-bmc', 'primary', 'btn-ok');
        } else if (val === 'stopped') {
          ele.setAttribute('data-action', 'start');
          ele.setAttribute('title', '');
          ele.classList.add('btn', 'btn-bmc', 'primary', 'btn-ok');
        } else if (val === 'starting') {
          ele.setAttribute('data-action', 'starting');
          ele.setAttribute('title', 'Starting the stream. This may take a few minutes. Thank you for your patience.');
          ele.classList.remove('btn', 'btn-bmc', 'primary', 'btn-ok');
        } else if (val === 'stopping') {
          ele.setAttribute('data-action', 'stopping');
          ele.setAttribute('title', 'Stopping the stream. Please Wait...');
          ele.classList.remove('btn', 'btn-bmc', 'primary', 'btn-ok');
        }
      });
      this.$watch('sid', (val) => {
        ele.setAttribute('data-sid', val);
      });

      const state_handler = (data) => {
        // console.log("BroadcastButton state_handler", data, this.nid);
        const {user, nid: _nid, sid, state, is_recording = false} = data;
        if (this.nid == _nid) {
          if (state) {
            this.status = state;
          }
          this.is_recording = is_recording;
        }
      };
      ele.addEventListener('interactive_meeting_broadcast_state_change', (e) => {
        // console.log('BroadcastButton interactive_meeting_broadcast_state_change', e.detail);
        state_handler(e.detail);
      });

      const state_fetcher = Toolbox?.snExpoSessionLocation?._fetch_broadcast_state;
      if (typeof state_fetcher === 'function') {
        state_fetcher(this.nid).then(state_handler);
      }

    },
    handleClick: function () {
      // console.log('handleClick', {status: this.status, text: this.text, showSpinner: this.showSpinner});
      if (this.status !== 'stopped' && this.status !== 'started') {
        return false;
      }
      if (this.status === 'started') {
        const end_popup_option = Object.assign({}, popup_option, {extra_class: ['broadcast-confirm-modal', 'sn-modal-scaleable', 'broadcast-end-modal']});
        let html = $jq.i18n.prop('msg_are_you_sure_you_want_to_end');
        let title = $jq.i18n.prop('msg_end_broadcast');
        if (this.is_recording) {
          html = $jq.i18n.prop('msg_are_you_sure_you_want_to_end_with_record');
          title = $jq.i18n.prop('msg_end_broadcast_with_record');
        }
        SNModal.confirm(html, () => {
          this.status = 'stopping';
          fetch(`${_base_url()}/wowza/broadcast/stop/${this.nid}`).then(rsp => rsp.json()).then((data) => {
            const {state} = data;
            if (state === 'stopping' && this.status === 'stopped') {
              this.status = state;
            }
          });
        }, $jq.noop, $jq.i18n.prop('msg_end'), $jq.i18n.prop('msg_cancel'), title, true, end_popup_option);
      }
      if (this.status === 'stopped') {
        let html = $jq.i18n.prop('msg_broadcast_will_stream_the_on');
        if (this.backend === 4 || this.backend === 5) {
          html += `<p><input type='checkbox' id="recording-checkbox" name='recording' class="bmc-checkbox" checked><label for="recording-checkbox">${$jq.i18n.prop('msg_record_broadcast')}</label></p>`;
        }
        SNModal.confirm(html, () => {
          this.status = 'starting';
          let is_recording = SNModal.dialog.find('input[name=recording]:checked').length > 0;
          const request_url = `${_base_url()}/wowza/broadcast/start/${this.nid}?recording=${is_recording ? 1 : 0}`;
          fetch(request_url).then(rsp => rsp.json()).then((data) => {
            const {sid, error, state} = data;
            if (sid) {
              this.sid = sid;
            }
            if (state) {
              this.status = state;
            }
            if (error) {
              SNModal.alert(error);
            }
          });
        }, $jq.noop, $jq.i18n.prop('msg_start_broadcast'), $jq.i18n.prop('msg_cancel'), $jq.i18n.prop('msg_broadcast_and_record'), true, popup_option);
      }
    }
  }
}